import { render, staticRenderFns } from "./pendWarning.vue?vue&type=template&id=46f05311&scoped=true&"
import script from "./pendWarning.vue?vue&type=script&lang=js&"
export * from "./pendWarning.vue?vue&type=script&lang=js&"
import style0 from "./pendWarning.vue?vue&type=style&index=0&id=46f05311&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f05311",
  null
  
)

component.options.__file = "pendWarning.vue"
export default component.exports